import { removeSpaces } from '@common/utils/fileNameHelpers';
import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';

import {
  DiagnosticsColumnDefinitions,
} from './columnDefinitions';
import {
  TaxBookingDiagnosticsList,
  CurrenciesDiagnosticsList,
  ObligationDiagnosticsList,
  CompanyCodeDiagnosticsList,
  LegalEntityDiagnosticsList,
  ProvisionDiagnosticsList,
} from '@common/schemas/diagnostics';
import { PillTypes } from './constants';

type DownloadDiagnosticsXlsxParams = {
  periodName: string,
  data: {
    [PillTypes.TAX_BOOKING_ENTITIES]: TaxBookingDiagnosticsList,
    [PillTypes.CURRENCIES]: CurrenciesDiagnosticsList,
    [PillTypes.OBLIGATION]: ObligationDiagnosticsList,
    [PillTypes.COMPANY_CODE]: CompanyCodeDiagnosticsList,
    [PillTypes.LEGAL_ENTITY]: LegalEntityDiagnosticsList,
    [PillTypes.PROVISION]: ProvisionDiagnosticsList,
  },
  environmentSuffix: string,
  shouldDisplayZero: boolean,
  hideDecimals: boolean,
  negativeMinus: boolean,
}

export const downloadDiagnosticsXlsx = ({
  periodName,
  data,
  shouldDisplayZero,
  hideDecimals,
  negativeMinus,
  environmentSuffix,
}: DownloadDiagnosticsXlsxParams) => {
  const sheetData = [
    {
      name: 'Company Codes',
      data: data[PillTypes.COMPANY_CODE],
      columnDefinitions: DiagnosticsColumnDefinitions.companyCodesColumnDefinitions,
      type: SheetExportTypes.GRID,
      options: {
        shouldDisplayZero,
        hideDecimals,
        negativeMinus,
      },
    },
    {
      name: 'Legal Entity',
      data: data[PillTypes.LEGAL_ENTITY],
      columnDefinitions: DiagnosticsColumnDefinitions.legalEntityColumnDefinitions,
      type: SheetExportTypes.GRID,
      options: {
        shouldDisplayZero,
        hideDecimals,
        negativeMinus,
      },
    },
    {
      name: 'Currency Conversion Rates',
      data: data[PillTypes.CURRENCIES],
      columnDefinitions: DiagnosticsColumnDefinitions.currenciesColumnDefinitions,
      type: SheetExportTypes.GRID,
      options: {
        shouldDisplayZero,
        hideDecimals,
        negativeMinus,
      },
    },
    {
      name: 'Obligation',
      data: data[PillTypes.OBLIGATION],
      columnDefinitions: DiagnosticsColumnDefinitions.obligationsColumnDefinitions,
      type: SheetExportTypes.GRID,
      options: {
        shouldDisplayZero,
        hideDecimals,
        negativeMinus,
      },
    },
    {
      name: 'Tax Booking Entities',
      data: data[PillTypes.TAX_BOOKING_ENTITIES],
      columnDefinitions: DiagnosticsColumnDefinitions.taxBookingEntitiesColumnDefinitions,
      type: SheetExportTypes.GRID,
      options: {
        shouldDisplayZero,
        hideDecimals,
        negativeMinus,
      },
    },
    {
      name: 'Provision',
      data: data[PillTypes.PROVISION],
      columnDefinitions: DiagnosticsColumnDefinitions.provisionColumnDefinitions,
      type: SheetExportTypes.GRID,
      options: {
        shouldDisplayZero,
        hideDecimals,
        negativeMinus,
      },
    },
  ];

  return xlsxExport({
    sheetData,
    metadata: {
      fileName: removeSpaces(`TLS_diagnostics_${periodName}_${environmentSuffix}`),
      disableHeaderRendering: true,
    },
  });
};
